export const LOADING = 'LOADING';
export const GET_SURVEY = 'GET_SURVEY';
export const SET_ERRORS = 'SET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SUCCESS_FEEDBACK = "SUCCESS_FEEDBACK";
export const FAIL_FEEDBACK = "FAIL_FEEDBACK";
